import type { CarStats, CarUpgrade } from "./CarStats.js";

/**
 * Per-stat multipliers for each upgrade level [L1, L2, L3].
 * Applied multiplicatively: result[stat] *= multipliers[level - 1]
 *
 * Design notes:
 * - engine:     primary power — accel and topSpeed
 * - gearbox:    low-end torque — smaller accel gains + audio shift speed
 * - turbo:      boost magnitude — boostPower only (primary source)
 * - suspension: contact patch — traction and downforce
 * - aero:       airflow — topSpeed and downforce
 * - brakes:     stopping — brakeForce only
 * - boost:      secondary boostPower + future BOOST_MAX_ENERGY hook
 *
 * Ceiling check: turbo L3 + boost L3 → boostPower = 1.0 * 1.40 * 1.14 = 1.596
 */
export type UpgradeModifiers = {
  readonly [K in keyof CarStats]?: readonly [number, number, number];
};

export const UPGRADE_MODIFIERS: Record<keyof CarUpgrade, UpgradeModifiers> = {
  engine: {
    accel:    [1.10, 1.22, 1.38],
    topSpeed: [1.05, 1.10, 1.16],
  },
  gearbox: {
    accel:         [1.06, 1.12, 1.18],
    gearShiftSpeed:[1.08, 1.18, 1.30],
  },
  turbo: {
    boostPower: [1.10, 1.22, 1.40],
  },
  suspension: {
    traction:  [1.08, 1.18, 1.30],
    downforce: [1.10, 1.22, 1.38],
  },
  aero: {
    topSpeed:  [1.04, 1.08, 1.13],
    downforce: [1.08, 1.18, 1.28],
  },
  brakes: {
    brakeForce: [1.12, 1.26, 1.45],
  },
  boost: {
    boostPower: [1.04, 1.08, 1.14],
  },
};
